function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.78711 7.18555L9.96875 6.99219C10.291 6.6582 10.2969 6.26562 9.96289 5.93164L9.79883 5.76758C10.7305 4.94727 11.7383 4.86523 12.3945 4.20312C13.3027 3.2832 13.0684 1.95898 12.3711 1.25586C11.6797 0.552734 10.3555 0.330078 9.42383 1.23242C8.75586 1.88281 8.67969 2.89648 7.85938 3.82812L7.70117 3.66406C7.36719 3.32422 6.96875 3.33594 6.63477 3.6582L6.44141 3.83984C6.04883 4.20898 6.10742 4.56055 6.45898 4.90625L6.69336 5.14648L2.4043 9.43555C0.517578 11.3223 1.26758 11.2871 0.347656 12.5645L0.951172 13.1973C2.1875 12.2773 2.25781 13.1094 4.16211 11.2168L8.48047 6.92773L8.7207 7.16797C9.07227 7.51367 9.41211 7.57227 9.78711 7.18555ZM4.92969 8.72656C4.73633 8.50977 4.77734 8.31055 4.98828 8.09375L7.30859 5.75586L7.88281 6.33008L5.54492 8.67383C5.35156 8.86133 5.11133 8.91992 4.92969 8.72656Z",
  fill: "#BFBBCF"
});

function SvgIconPalettes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPalettes);
export default __webpack_public_path__ + "static/media/icon-palettes.37ebb2d6.svg";
export { ForwardRef as ReactComponent };